var perLocaleConfig = {
  sk: {
    trackerId: '8760-9189',
  },
  dev: {
    trackerId: '8760-122186',
  },
  cs: {
    trackerId: '8760-10679',
  },
  en: {
    trackerId: '8760-25171',
  },
  hu: {
    trackerId: '8760-10688',
  },
  hr: {
    trackerId: '8760-10865',
  },
  de: {
    trackerId: '8760-10777',
  },
  sl: {
    trackerId: '8760-24134',
  },
  ro: {
    trackerId: '8760-10884',
  },
  pl: {
    trackerId: '8760-114954',
  },
  it: {
    trackerId: '8760-115859',
  },
  fr: {
    trackerId: '8760-115916',
  },
  bg: {
    trackerId: '8760-116004',
  },
  es: {
    trackerId: '8760-332506',
  },
  el: {
    trackerId: '8760-343501',
  },
  sr: {
    trackerId: '8760-381911',
  },
  uk: {
    trackerId: '8760-407520',
  },
  nl: {
    trackerId: '8760-424605',
  },
  da: {
    trackerId: '8760-476823',
  },
  sv: {
    trackerId: '8760-499595',
  },
  pt: {
    trackerId: '8760-499629',
  },
  fi: {
    trackerId: '8760-499628',
  },
  et: {
    trackerId: '8760-843626',
  },
};

var stockStatuses = {
  on_stock_digital: 'green',
  not_in_stock_digital: 'red',
  on_stock: 'green',
  is_in_stock_retail: 'orange',
  on_order: 'orange',
  at_supplier: 'orange',
  available_to_order: 'red',
  not_in_stock: 'red',
  long_term_unavailable: 'red',
};

var getCurrentLocale = function () {
  var currentLocale = document.body ? document.body.getAttribute('data-locale') : null;
  return currentLocale;
};

var getDefaultLocale = function () {
  var defaultLocale = document.body ? document.body.getAttribute('data-default-locale') : null;
  return defaultLocale;
};

var getLocationDomain = function () {
  return document.body && document.body.getAttribute('data-legal')
    ? document.body.getAttribute('data-legal')
    : 'DEFAULT';
};

window.setupAutocomplete = function () {
  var domainConfig = perLocaleConfig[getCurrentLocale()];
  if (location.href.includes('staging') || location.href.includes('staging-dev')) {
    domainConfig = perLocaleConfig['dev'];
  }
  if (domainConfig) {
    var cookiesEnabled = (function (e) {
      try {
        e.cookie = 'ct=1';
        var t = -1 !== e.cookie.indexOf('ct=');
        return (e.cookie = 'ct=1; expires=Thu, 01-Jan-1970 00:00:01 GMT'), t;
      } catch (i) {
        return !1;
      }
    })(document);
    !(function (e, t, i) {
      if (t) {
        i &&
          ('undefined' != typeof Luigis && (Luigis.lint = !0),
          sessionStorage.setItem('_lb_lint', '{"enable":true}'));
        var r = e.getElementsByTagName('head')[0],
          o = e.createElement('script');
        (o.async = 1),
          (o.src = 'https://cdn.luigisbox.com/muziker.js'),
          o.setAttribute('data-luigisbox-tracker-id', domainConfig.trackerId),
          r.appendChild(o);
      }
    })(document, cookiesEnabled);
    var settings = {
      autocomplete: {
        Layout: 'line',
        TrackerId: domainConfig.trackerId,
        Personalization: true,
        Types: [
          {
            type: 'query',
            placement: 'others',
            size: 5,
          },
          {
            name: I18n.t('js.public.autocomplete.category_name'),
            type: 'category',
            placement: 'others',
            size: 5,
            defaultFilters: { visibility: 'search' },
          },
          {
            type: 'brand',
            name: I18n.t('js.public.autocomplete.brand_name'),
            size: 4,
            attributes: ['sku.hl'],
            placement: 'others',
          },
          {
            type: 'article',
            name: I18n.t('js.public.autocomplete.article_name'),
            size: 3,
            attributes: [],
            placement: 'others',
          },
          {
            type: 'item',
            placement: 'main',
            size: 4,
            attributes: ['product_category'],
            defaultFilters: { visible_in: getLocationDomain() },
          },
        ],
        ShowAllTitle: I18n.t('js.public.autocomplete.show_all_title') || '',
        ShowAllPlacement: 'main',
        Width: '',
        Align: 'center',
        CloseWhenQueryIsEmpty: false,
        PostponeDataCollection: true,
        Hint: function (e) {
          return 'Pre vyh\u013eadanie $query stla\u010dte Enter'.replace(
            /\$query/,
            '<b>' + e + '</b>'
          );
        },
        FormatForDisplay: function (e) {
          e._before_price = '';
          e._after_price = '';

          couponPriceAmount = e.attributes[`coupon_price_${getLocationDomain()}`];
          couponCode = e.attributes[`coupon_code_${getLocationDomain()}`];

          if (couponPriceAmount && couponCode) {
            e._before_price += `<div class="luigi-ac-campaign-coupon-price apply-campaign-coupon">
              <strong>${couponPriceAmount}</strong>
              ${I18n.t('js.public.autocomplete.with_code')}
              <strong>${couponCode[0]}</strong>
            </div><div class="luigi-ac-campaign-coupon-price-separator"></div>`;
          }

          if (e.attributes['price_' + getLocationDomain()]) {
            e.attributes.price = e.attributes['price_' + getLocationDomain()];
            e.attributes.price_amount = e.attributes['price_' + getLocationDomain() + '_amount'];
          }

          if (
            e.attributes['price_old_' + getLocationDomain()] &&
            e.attributes['price_old_' + getLocationDomain() + '_amount'] !==
              e.attributes['price_' + getLocationDomain() + '_amount']
          ) {
            e.attributes.price_old = e.attributes['price_old_' + getLocationDomain()];
            e._after_price = `<div class="luigi-ac-price-old">${
              e.attributes['price_old_' + getLocationDomain()]
            }</div>`;
          }

          if (e.attributes.eshop_statuses) {
            var countryCode = getLocationDomain();
            var canBuyInStore = countryCode === 'SK' || countryCode === 'CZ';
            var eshopStatus = e.attributes.eshop_statuses
              ? e.attributes.eshop_statuses[0] === 'is_in_stock_retail'
                ? canBuyInStore
                  ? e.attributes.eshop_statuses[0]
                  : e.attributes.eshop_statuses[1]
                : e.attributes.eshop_statuses[0]
              : '';

            e._after_price += `<div class="stock-status mzkr-text-xs ${
              stockStatuses[eshopStatus]
            }">${I18n.t(`js.public.products.eshop_statuses.${eshopStatus}`)}</div>`;
          }

          if (e.attributes.variant?.length > 1) {
            e._after_price += `<div class="badge badge-virtual-product-variants">
            ${I18n.t(`js.public.products.show.labels.virtual_product_variants`, {
              count: `${e.attributes.variant.length}`,
            })}</div> `;
          }

          if (
            !(
              e.attributes.is_product_ask_price ||
              (e.attributes.is_unsaleable &&
                e.attributes.is_unsaleable.length > 0 &&
                e.attributes.is_unsaleable[0]) ||
              (e.attributes.status &&
                e.attributes.status.length > 0 &&
                e.attributes.status[0] == 'ended')
            ) &&
            (!e.attributes.action_type ||
              (e.attributes.action_type.length > 0 &&
                e.attributes.action_type[0] == 'add_to_basket'))
          ) {
            e.attributes.product_is_for_sale = true;
          } else {
            e.attributes.product_is_for_sale = false;
          }
          return e && 'item' == e.type && window._itemsCounter < 7
            ? (window._itemsCounter++, e)
            : e && 'category' == e.type && window._categoriesCounter < 5
            ? (window._categoriesCounter++, e)
            : e && 'category' != e.type && 'item' != e.type
            ? e
            : null;
        },
        NoResultsMessage: function (e, t) {
          return 0 == t
            ? I18n.t('js.public.autocomplete.no_results_phrase_before') +
                ' "' +
                e +
                '" ' +
                I18n.t('js.public.autocomplete.no_results_phrase_after')
            : I18n.t('js.public.autocomplete.oneResultBefore') +
                ' "' +
                e +
                '" ' +
                I18n.t('js.public.autocomplete.oneResultAfter');
        },
        Select: function () {
          PublicUtility.Search.hideSearch();
        },
        BeforeOpen: function (a, b) {
          PublicUtility.Search.openSearch();
        },
        AfterRender: function (a, b, emitAnalyticsEventFn) {
          var resultsLinks = document.querySelectorAll('a.luigi-ac-item');

          for (var i = 0; i < resultsLinks.length; i++) {
            var resultElementLink = resultsLinks[i];

            if (getDefaultLocale() !== getCurrentLocale()) {
              resultElementLink.setAttribute(
                'href',
                `/${getCurrentLocale()}${resultElementLink.getAttribute('href')}`
              );
            }
          }

          var results = document.querySelectorAll('.luigi-ac-item .luigi-ac-product');
          for (var i = 0; i < results.length; i++) {
            var price = results[i].querySelector('.luigi-ac-price');

            var dualPrice = document.createElement('div');
            var showDualPriceRate = parseFloat(
              document.body.getAttribute('data-show-dual-price-rate')
            );
            var showDualPriceCurrency = document.body.getAttribute('data-show-dual-price-currency');

            if (showDualPriceRate && showDualPriceCurrency) {
              var priceAmount = price.querySelector("[itemprop='price']").getAttribute('content');
              var newPrice = PublicUtility.CurrencyFormatManager.number_to_currency(
                priceAmount * showDualPriceRate,
                showDualPriceCurrency
              );
              dualPrice.setAttribute(
                'class',
                'luigi-ac-price-new mzkr-text-light mzkr-text-sm mzkr-mr-2'
              );
              dualPrice.textContent = newPrice;
              price.prepend(dualPrice);
            }
          }
          (window._itemsCounter = 0), (window._categoriesCounter = 0), this._Position();

          if (b && b.length === 0) {
            this.OpenEmpty(
              `<div class='mzkr-mx-auto mzkr-mt-12'>${I18n.t(
                'js.public.autocomplete.no_results_phrase_before'
              )} ${a} ${I18n.t('js.public.autocomplete.no_results_phrase_after')}</div>`
            );
          }

          emitAnalyticsEventFn();
        },
        ShowBranding: !1,
        ShowHeroProduct: !1,
        AutoReposition: false,
        GridPosition: 'right',
        PlaceholderText: I18n.t('js.public.autocomplete.placeholder_text'),
      },
      selector: '#global-search',
      initialize: function () {
        if (document.querySelector('#global-search')) {
          document.querySelector('#global-search').addEventListener('keydown', function (e) {
            if (window.Luigis && window.Luigis.Search && window.Luigis.Search.Push) {
              return;
            }
            if (e.keyCode === 13 && document.querySelector('#global-search').value === '') {
              e.preventDefault();
              return false;
            }
            if (e.keyCode === 13) {
              document.querySelector('#global-search').form.submit();
              e.preventDefault();
            }
          });
        }
      },
    };

    if (document.querySelector('body').getAttribute('data-segment-name')) {
      settings.autocomplete.Prefer = [
        `categories_lvl_1:${document.querySelector('body').getAttribute('data-segment-name')}`,
      ];
    }

    !(function (doc, acSettings, sSettings) {
      (initializeAutocomplete = function (e) {
        var t = doc.getElementsByTagName('head')[0],
          i = doc.createElement('script');
        (i.src = 'https://cdn.luigisbox.com/autocomplete.js'),
          i.addEventListener('load', function () {
            window.autoComplete = AutoComplete(
              e.autocomplete,
              e.selector,
              document,
              e.waitForSelectors
            );
          }),
          t.appendChild(i);
        document.addEventListener('turbo:render', function () {
          if (!document.querySelector('.luigi-ac')) {
            AutoComplete(e.autocomplete, e.selector, document, e.waitForSelectors);
          }
        });
        e.initialize && e.initialize(e);
      }),
        (initializeSearch = function (e, t) {
          var i = doc.getElementsByTagName('head')[0],
            r = doc.createElement('script');
          if (
            ((r.src =
              !0 === t
                ? 'https://cdn.luigisbox.com/search.debug.js'
                : 'https://cdn.luigisbox.com/search.js'),
            r.addEventListener('load', function () {
              Luigis.Search(e.search, e.inputSelector, e.wrapperElementSelector);
            }),
            i.appendChild(r),
            e.hasOwnProperty('styles'))
          ) {
            var o = document.createElement('style');
            (o.type = 'text/css'),
              o.styleSheet
                ? (o.styleSheet.cssText = e.styles)
                : o.appendChild(document.createTextNode(e.styles)),
              i.insertBefore(o, i.firstElementChild);
          }
          if (e.hasOwnProperty('templates'))
            for (var a in e.templates) {
              var n = document.createElement('script');
              (n.type = 'text/x-template'),
                (n.id = a),
                (n.textContent = e.templates[a]),
                i.insertBefore(n, i.firstElementChild);
            }
        }),
        (acSettings && initializeAutocomplete(acSettings),
        sSettings && initializeSearch(sSettings));
    })(
      document,
      void 0 !== settings ? settings : null,
      'undefined' != typeof searchSettings ? searchSettings : null
    );
  }
};

setTimeout(function () {
  window.autocompleteInitLoaded = true;
}, 100);
